import rootReducer from "./store/reducers/rootReducer";
import { persistStore } from "redux-persist";// tạo một "persistor" để quản lý quá trình lưu trữ và phục hồi trạng thái 
import { createStore, applyMiddleware } from "redux";
import thunk from 'redux-thunk'
const reduxStore = () => {
    const store = createStore(rootReducer, applyMiddleware(thunk))
    const persistor = persistStore(store)
    return { store, persistor }
}

export default reduxStore
/*  tạo ra một Redux Store bằng cách sử dụng createStore từ Redux, kết hợp với Redux Persist để quản lý lưu trữ bản cục. Khi bạn sử dụng hàm 
reduxStore này trong ứng dụng của bạn, bạn sẽ có một Redux Store đã được cấu hình sẵn sàng để sử dụng Redux Persist để lưu trữ và phục hồi trạng 
thái của ứng dụng.*/